import { useState } from "react";
import { Button, ErrorWithString } from "../../../../components/RegularComponents";
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from "../../../../app/errors";
import { ValidateString } from "../../../../app/utils";
import { useDispatch } from "react-redux";
import { fetchLoginSearchResponse } from "../../../../redux/slice/businessLicenceApplicationSlice";
import {
  LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION
} from "../../../../app/constants";

const ChangeLoginUserForm = (props) => {
  const dispatch = useDispatch();
  const [newLoginId, setNewLoginId] = useState("");
  const [emailValidationError, setEmailValidationError] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [showResultView, setShowResultView] = useState(false);

  const isMortgageBrokerageApp =
    props.application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION ||
    props.application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION;

  const saveBtnLabel = isMortgageBrokerageApp
    ? "Change Principal Broker"
    : "Change Compliance Officer";

  const onSearchButtonClick = () => {
    const ret = ValidateString(newLoginId, VALIDATION_TYPE.EMAIL);
    if (ret !== VALIDATION_ERROR.NO_ERROR) {
      setEmailValidationError(ret);
      return;
    }

    dispatch(fetchLoginSearchResponse({ email: newLoginId })).then((resp) => {
      setSearchResults(resp);
      setShowResultView(true);
    });
  };

  const emailErrorString = () => {
    switch (emailValidationError) {
      case VALIDATION_ERROR.EMAIL_INVALID:
        return ERROR_STRING.CONTACT_DETAILS_EMAIL_INVALID;
      case VALIDATION_ERROR.EMPTY:
      default:
        return ERROR_STRING.CONTACT_DETAILS_EMAIL_EMPTY;
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <label>{props.userEmail}</label>
      <fieldset className="ns-fieldset topMarginLarge" id="name-edit-form">
        <label className="ns-label" autoComplete="email" htmlFor="loginSearch">
          Search User
        </label>
        <div className="ns-fieldset bottomMarginNormal">
          <div style={{ display: "flex", width: "100%" }}>
            <input
              className="fw-25 ns-input"
              type="email"
              id="searchUserLogin"
              name="searchUserLogin"
              value={newLoginId}
              onChange={(e) => {
                // onChange("firstName", e.target.value)
                setNewLoginId(e.target.value);
                if (emailValidationError) {
                  setEmailValidationError("");
                }
                if (showResultView) {
                  setShowResultView(false);
                  setSearchResults(null);
                }
              }}
            />
            <Button buttonType="regular_primary" text={"Search"} onClick={onSearchButtonClick} />
          </div>
          {emailValidationError ? (
            <span className="ns-error-message field-validation-error">
              {ErrorWithString(emailErrorString())}
            </span>
          ) : null}
        </div>
        <SearchedList
          searchResults={searchResults}
          showResultView={showResultView}
          newLoginId={newLoginId}
        />
        <div className="topMarginNormal">
          <Button
            buttonType="regular_success"
            text={saveBtnLabel}
            disabled={
              !searchResults?.length ||
              (!showResultView && emailErrorString() !== VALIDATION_ERROR.NO_ERROR)
            }
            onClick={() => props.handleLoginChangeSave(searchResults[0])}
          />
        </div>
      </fieldset>
    </div>
  );
};

function SearchedList(props) {
  if (!props.showResultView) {
    return null;
  }

  return (
    <div>
      {props.searchResults?.length ? (
        <>
          <b>{"User Found : "}</b>
          <ul>
            {props.searchResults?.map((user, i) => {
              return <li key={i}>{user.emailAddress}</li>;
            })}
          </ul>
        </>
      ) : (
        <div>
          <b>{"No user found for : "}</b>
          {props.newLoginId}
        </div>
      )}
    </div>
  );
}

export default ChangeLoginUserForm;
